export default __webpack_public_path__ + "static/media/1009.6f3fd23a.svg";